import gql from 'graphql-tag';

export const QueryHiringManagersByCompanyId = gql`
	query QueryHiringManagersByCompanyId($companyId: ID!) {
		queryHiringManagersByCompanyId(companyId: $companyId) {
			employeeId
			firstName
			lastName
		}
	}
`;
